import CustomModal from '../../../../../components/Modal/CustomModal';
import {
    IconAvatarTable,
    IconEntryDevice,
    ImgCheckInHeader,
} from '../../../../../components/buttons/IconButtons';
import CustomCard from '../../../../../components/CustomCard';
import React from 'react';
import {LogModalApp} from '../Functionality/LogModalApp';
import LogCardModal from './LogCardModal';

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 03 de diciembre de 2025
 */

const LogModal  = (props) => {
    const { onHide, itemSelected, out } = props

    const {
        t,
        checkInItem,
        checkOutItem,
        equipmentIn,
        equipmentOut
    } = LogModalApp({
        itemSelected,
        out
    });

    return (
        <CustomModal
            {...props}
            size='lg'
            classNameBody="m-0 p-0"
            onHide={onHide}
            cancelButton={false}
            confirmButton={false}
            topLeftHeader={
                <div className={'d-flex align-items-center'}>
                    <IconEntryDevice className={'w-32px h-32px'}/>
                    <p className={'fs-modal-title ibl-font-w-600 font-color-general-950 ml-2 text-uppercase'}>{out ? t('check_out_log') : t("check_in_log")}</p>
                </div>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <ImgCheckInHeader className={'w-100'}/>
                <div className={'row my-3'}>
                    <div className={'col-12 d-flex justify-content-between'}>
                        <div className={'d-flex justify-content-start align-items-center'}>
                            <IconAvatarTable/>
                            <p className={'text-capitalize font-color-general-950 fs-14px ml-2'}>{itemSelected?.userFullName}</p>
                        </div>
                    </div>
                </div>
                <div className={'border-bottom-shades-300'}/>
                <div className={"p-3"}>
                    <LogCardModal
                        t={t}
                        checkInItem={checkInItem}
                        checkOutItem={checkOutItem}
                        out={out}
                        equipmentIn={equipmentIn}
                        equipmentOut={equipmentOut}
                    />
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default LogModal
